<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/returnException";
export default {
  name: "analysisReturnException",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$tz("日期,类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "RETURNS_PACKAGE_SELECT"
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "warehouse_id",
            placeholder() {
              return this.$tz("仓库");
            },
            component: "Select",
            options: [],
            optionsFn: "getWarehouse",
            optionsKey: ""
          },
          {
            key: "status",
            placeholder() {
              return this.$tz("状态");
            },
            component: "Select",
            options: [
              {
                label: this.$tz("未处理"),
                value: 1
              },
              {
                label: this.$tz("已处理"),
                value: 2
              }
            ],
            optionsFn: "",
            optionsKey: ""
          },
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户");
            },
            component: "Select",
            options: [],
            optionsFn: "customer",
            optionsKey: ""
          },
          {
            key: "exception_type",
            placeholder() {
              return this.$tz("异常,原因");
            },
            component: "Select",
            options: [],
            optionsFn: "timeoutType",
            optionsKey: ""
          },
          {
            key: "customer_service",
            placeholder() {
              return this.$tz("客服");
            },
            component: "Select",
            options: [],
            optionsKey: "",
            optionsFn: "service",
            optionsKey: "",
            apiData: [1]
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              disabled() {
                return this.selectAll.length == 0;
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center"
        },
        {
          name: () => this.$tz("订单号码"),
          key: "airway_number",
          minWidth: 130
        },
        {
          name: () => this.$tz("仓库"),
          key: "warehouse",
          minWidth: 130
        },
        {
          name: () => this.$tz("异常,原因"),
          key: "exception_type",
          minWidth: 130
        },
        {
          name: () => this.$tz("客户,名称"),
          key: "client",
          minWidth: 130
        },
        {
          name: () => this.$tz("客服,名称"),
          key: "customer_service",
          minWidth: 130
        },
        {
          name: () => this.$tz("异常,时间"),
          key: "create_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("装袋,时间"),
          key: "package_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("提交,方案,时间"),
          key: "plan_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("完结,时间"),
          key: "complete_time",
          minWidth: 130
        }
      ]
    };
  }
};
</script>

<style scoped></style>
